enum TabStatus {
   DETAILS = 0,
   IMAGES = 1,
   OTHER = 2,
   RENTAL = 3,
   NOTES = 4,
   HISTORY = 5,
   MAP = 6,
   INVENTORY = 7,
   TASKS = 8,
}

const crudItemTabs = [
   { label: 'Details', status: TabStatus.DETAILS },
   { label: 'Inventory', status: TabStatus.INVENTORY },
   { label: 'Images', status: TabStatus.IMAGES },
   { label: 'Other', status: TabStatus.OTHER },
   { label: 'Rental', status: TabStatus.RENTAL },
   { label: 'Tasks', status: TabStatus.TASKS },
   { label: 'Notes', status: TabStatus.NOTES },
   { label: 'History', status: TabStatus.HISTORY },
   { label: 'Map', status: TabStatus.MAP },
]

export { crudItemTabs, TabStatus }
